<div class="error-popup">
  <div class="error-body">
    <div class="close-btn" (click)="hidePopupClick()"></div>
    <p>{{errorMsg}}</p>
  </div>
</div>